import React from "react";
import './About.css'
import {useMediaQuery,useTheme,} from "@mui/material";
import { AboutDesktop } from "./AboutDesktopView/AboutDesktop";
import { AboutMobile } from "./AboutMobileView/AboutMobile";

const About = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
    {!isMobile && <AboutDesktop/>}
    {isMobile && <AboutMobile/>}
    </>
  );
};

export default About;